module.exports = __webpack_public_path__ + "static/media/麻辣鍋.1c51c7ad.jpg";